import React from "react";
import Card from "react-bootstrap/Card";
import { selectLocationByCode } from "../features/rapidstor/rapidstorApiSlice";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import classes from "./LocationCard.module.scss";
import Image from "react-bootstrap/Image";
import { ReactComponent as IconRightChevron } from "../assets/icon-right-chevron.svg";

interface Props {
  locationCode: string;
}

function LocationCard({ locationCode }: Props) {
  const location = useSelector((state: RootState) =>
    selectLocationByCode(state, locationCode)
  );

  // This might happen if LocationCard is called with a location code that
  // hasn't been loaded yet.
  // @TODO: replace with ghost element
  if (!location) {
    return <></>;
  }

  const addressLine = [location.address.address1, location.address.address2]
    .filter(Boolean)
    .join(" ");

  return (
    <Card className={`${classes.card} ${classes.expanded} ${classes.location}`}>
      <Card.Body className={classes.cardBody}>
        <Image src={location.settings.logo} className={classes.photo} />
        <div className={classes.facilityInfo}>
          <div className={classes.name}>Storage {location?.name}</div>
          <div className={classes.address}>
            {addressLine}, {location.address.city} {location.address.region}
          </div>
        </div>
        <IconRightChevron className={`flex-shrink-0 ${classes.arrow}`} />
      </Card.Body>
    </Card>
  );
}

export default LocationCard;
